import { jsx as _jsx } from "react/jsx-runtime";
import UIComponent from './uiComponent';
import UIContainer from './uiContainer';
export default class UIAligner extends UIComponent {
    alignment;
    constructor(s) {
        super(s);
        this.alignment = this.getProperty('align', 'left');
        const container = new UIContainer(s);
        this.children.push(container);
    }
    getComponent() {
        const content = this.children[0].getComponent();
        if (this.alignment === 'left') {
            const divStyle = {
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
            };
            return _jsx("div", { style: divStyle, children: content });
        }
        else if (this.alignment == 'right') {
            const divStyle = {
                display: 'flex',
                justifyContent: 'flex-end',
                alignItems: 'flex-end',
            };
            return _jsx("div", { style: divStyle, children: content });
        }
        return _jsx("div", {});
    }
}
//# sourceMappingURL=uiAligner.js.map